import { TextField } from "@mui/material";
import { handleWheel, handleKeyDown } from "../functions/eventHandlers";

const Integer64Entry = ({ elementName, fieldLabel, startingValue, setResourceState, marginTop, required }) => {
    return <TextField error={required && !startingValue}
        style={{ width: "100%", marginTop: marginTop || "12px" }} 
        className="inputField" type='number' inputMode='numeric' label={fieldLabel} size="small" variant='outlined'
        value={startingValue || ""}
        onWheel={handleWheel}
        onKeyDown={handleKeyDown}
        onChange={(e) => {
            setResourceState(prevState => { return { ...prevState, [elementName]: e.target.value } });
        }} />
};

export default Integer64Entry;